/* 🤖 this file was generated by svg-to-ts */
export const emperorIconPlug1: {
  name: 'plug_1';
  data: string;
} = {
  name: 'plug_1',
  data: `<svg viewBox="0 0 24 24" xmlns="http://www.w3.org/2000/svg"><path d="M12.0039 14C12.8323 14 13.5039 13.3284 13.5039 12.5C13.5039 11.6716 12.8323 11 12.0039 11C11.1755 11 10.5039 11.6716 10.5039 12.5C10.5039 13.3284 11.1755 14 12.0039 14Z"/><path d="M18.0039 5H16.0039V2H14.0039V5H10.0039V2H8.00391V5H6.00391C4.90091 5 4.00391 5.896 4.00391 7V10C4.00391 14.072 7.06391 17.436 11.0039 17.931V21H13.0039V17.931C16.9439 17.436 20.0039 14.073 20.0039 10V7C20.0039 5.896 19.1069 5 18.0039 5ZM18.0039 7V8H6.00391V7H18.0039ZM12.0039 16C8.69491 16 6.00391 13.309 6.00391 10H18.0039C18.0039 13.309 15.3129 16 12.0039 16Z"/></svg>`,
};
